






















import { defineComponent } from "@vue/composition-api";

const Component = defineComponent({});

export default Component;
